import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface EditResponse {
  user: string
  token: string
}

export interface EditSiteRequest {
  status: string,
  name: string,
  logo: string,
}

export interface EditRequest {
  page_id: number
  key?: string
  name?: string
  caption?: string
  visible?: boolean
  order?: number
  data?: any
}

export const panelApi = createApi({
  reducerPath: 'panelApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/panel',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['panel'],

  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: () => '/dashboard'
    }),
    getPages: builder.query({
      query: () => '/get-pages',
    }),
    getEdit: builder.query({
      query: (pageId) => '/edit/' + pageId,
      providesTags: ['panel']
    }),
    editTheme: builder.mutation<EditResponse, EditRequest>({
      query: (data) => ({
        url: '/editTheme',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['panel']
    }),
    editSite: builder.mutation<EditResponse, EditSiteRequest>({
      query: (data) => ({
        url: '/editSite',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['panel']
    }),
    checkDomain: builder.query({
      query: () => '/check-domain'
    }),
  }),
})

export const { useGetDashboardQuery ,useGetEditQuery, useGetPagesQuery , useEditThemeMutation, useEditSiteMutation, useCheckDomainQuery } = panelApi